import React from 'react';

import { useFormikContext } from 'formik';

import { camelToSpaceCase } from 'lib/helpers/utility';

import Checkbox from 'components/shared/Checkbox/Checkbox';
import RadioButton from 'components/shared/RadioButton/RadioButton';

const options = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Custom',
    value: 'custom'
  }
];

const ExportColumnsCheckbox = () => {
  const { values, setFieldValue, columns } = useFormikContext();

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Export Columns
        <span className="text-danger-400">*</span>
      </label>

      <div className="mt-2 flex gap-4">
        {options?.map((option, idx) => {
          const value = option?.value;

          return (
            <RadioButton
              key={idx}
              dataQA={`radio-${value}`}
              size="medium"
              isSelected={values?.export_columns?.includes(value)}
              onChange={() => setFieldValue('export_columns', [value])}
              label={option?.label}
              name="export_columns"
              wrapperClassName="w-max"
            />
          );
        })}
      </div>

      {values?.export_columns?.includes('custom') && (
        <div className="mt-4 grid grid-cols-2 gap-4">
          {columns?.map((option, idx) => {
            const value = option?.field;
            const isChecked = values?.selected_columns?.includes(value);

            return (
              <Checkbox
                key={idx}
                data-qa={`checkbox-${value}`}
                isChecked={isChecked}
                handleClick={() => {
                  const newValues = values?.selected_columns?.includes(value)
                    ? values?.selected_columns?.filter((val) => val !== value)
                    : [...(values?.selected_columns || []), value];

                  setFieldValue('selected_columns', newValues);
                }}
                label={option?.headerName || camelToSpaceCase(value)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExportColumnsCheckbox;
